/** BSC 主网代币与合约地址 */
export const USDT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955";
export const RAD_ADDRESS = "0xAbB0EDEeD1996C73C6B2E23a4d4B7e303B6906ab";
export const LOTTERY_ADDRESS = "0x332bf42D07E9F80cBEF7897525C5AD655Dbd04e0";
export const STAKE_ADDRESS = "0xa2a93188025Aa52915083Df41B0E7f6b1ef62A0d";

/** 前端路由 id → 合约 CardType 枚举 (NONE=0, GOLDEN=1, SILVER=2, BRONZE=3) */
export const FRONTEND_TO_CARD_TYPE = { 1: 2, 2: 1, 3: 3 };

export const CARD_TYPE_LABELS = { 1: "金卡", 2: "银卡", 3: "铜卡" };

export const CARD_TYPE_EMOJI = { 1: "🥇", 2: "🥈", 3: "🥉" };

/** 合约 CardType → 首页盲盒卡片静态配置 */
export const HOME_BLIND_BOX_META = [
  {
    cardType: 1,
    id: 2,
    namePrefix: "RAD金卡",
    displayPrice: 30000,
    image: require("@/assets/image/rad_card2.png"),
  },
  {
    cardType: 2,
    id: 1,
    namePrefix: "RAD银卡",
    displayPrice: 20000,
    image: require("@/assets/image/rad_card1.png"),
  },
  {
    cardType: 3,
    id: 3,
    namePrefix: "RAD铜卡",
    displayPrice: 10000,
    image: require("@/assets/image/rad_card3.png"),
  },
];

export const TOKEN_DECIMALS = 18;

export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

export function getCardTypeByFrontendId(frontendId) {
  const cardType = FRONTEND_TO_CARD_TYPE[Number(frontendId)];
  if (!cardType) {
    throw new Error(`无效的盲盒 id: ${frontendId}`);
  }
  return cardType;
}

/** NFT tokenId 区间 → 卡牌类型 */
export function getCardLevelByTokenId(tokenId) {
  const id = Number(tokenId);
  if (id >= 1 && id <= 2000) return "gold";
  if (id >= 2001 && id <= 7000) return "silver";
  if (id > 7000) return "bronze";
  return null;
}
